<template>
    <div id="custom-frame">
        <h1>Personalize your medical visit by choosing the desired timeframe:</h1>
        <div id="choices">
            <div class="choice">
                <div class="img-choice">
                    <img src="@/assets/svg/stopwatch.svg">
                </div>
                <router-link tag="button" to="#">
                    I don't have much time <br>
                    <small>(short version)</small>
                    →
                </router-link>
            </div>
            <div id="line-zone">
            </div>
            <div class="choice">
                <div class="img-choice">
                    <img src="@/assets/svg/coffee-cup.svg">
                </div>
                <router-link tag="button" to="/version-normale">May I offer you a coffee ? <br>
                    <small>(long version)</small>
                    →
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ChooseYourPath'
    }
</script>
<style lang="scss" scoped>

    #custom-frame {
        position: absolute;
        height: 80%;
        top: 10%;
        left: 10%;
        background-color: rgba(0, 0, 0, 0.51);
        color: #fff;
        width: 80%;
        padding: 30px 50px;
        box-sizing: border-box;
        padding: 3% 5%;
        h1 {
            text-align: center;
            font-size: 2vw;
            margin-top: 5%;
            font-weight: normal;
        }
        #choices {
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin: 10% 0;
            .choice {
                margin: 20px;
                text-align: center;

                img {
                    height: auto;
                    width: 30%;
                    -webkit-filter: drop-shadow(6px 9px 10px rgba(0, 0, 0, 0.5));
                    filter: drop-shadow(6px 9px 10px rgba(0, 0, 0, 0.5));
                }

                button {
                    border: 1px solid #fff;
                    background-color: transparent;
                    color: #fff;
                    padding: 20px 30px;
                    border-radius: 50px;
                    font-size: 1.5rem;
                    font-weight: bold;
                    margin-top: 15%;
                    transition: all 0.5s cubic-bezier(.25, .8, .25, 1);
                    cursor: pointer;
                    outline: none;
                    overflow: hidden;
                    position: relative;
                    text-align: left;
                    &:hover {
                        background-color: #2235a1;
                        border: 1px solid #2235a1;
                    }

                }
            }
            #line-zone {
                position: relative;
                min-height: 300px;
                &:after {
                    content: ' ';
                    position: absolute;
                    height: 100%;
                    width: 2px;
                    background-color: #fff;
                }

            }
        }
    }


</style>